'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _config = require('../../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('components');

var _SeeMoreModal = require('./SeeMoreModal.scss');

var _SeeMoreModal2 = _interopRequireDefault(_SeeMoreModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeeMoreModal = function (_Component) {
  (0, _inherits3.default)(SeeMoreModal, _Component);

  function SeeMoreModal() {
    (0, _classCallCheck3.default)(this, SeeMoreModal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(SeeMoreModal).apply(this, arguments));
  }

  (0, _createClass3.default)(SeeMoreModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props;
      var _onClose = _props.onClose;
      var item = _props.item;

      var baseUrl = item.image.substring(0, 4) == 'http' ? '' : _config2.default.assetsUrl;
      var imageUrl = baseUrl + item.image;
      return _react2.default.createElement(
        _components.Modal,
        { onClose: function onClose() {
            return _onClose();
          } },
        _react2.default.createElement(
          'div',
          { className: _SeeMoreModal2.default.content },
          _react2.default.createElement(
            'div',
            { className: 'grid' },
            _react2.default.createElement(
              'div',
              { className: 'col--1-of-4' },
              _react2.default.createElement('div', { className: _SeeMoreModal2.default.image, style: { backgroundImage: 'url(' + imageUrl + ')' } })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col--3-of-4' },
              _react2.default.createElement(
                'div',
                { className: _SeeMoreModal2.default.details },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Informations'
                ),
                _react2.default.createElement(
                  'div',
                  { className: _SeeMoreModal2.default.info },
                  _react2.default.createElement(
                    'label',
                    { className: _SeeMoreModal2.default.label },
                    'Product name'
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: _SeeMoreModal2.default.title },
                    item.title
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _SeeMoreModal2.default.info },
                  _react2.default.createElement(
                    'label',
                    { className: _SeeMoreModal2.default.label },
                    'description'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _SeeMoreModal2.default.description },
                    _react2.default.createElement(
                      'p',
                      null,
                      item.description
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: _SeeMoreModal2.default.productMeta },
                  _react2.default.createElement(
                    'div',
                    { className: _SeeMoreModal2.default.info },
                    _react2.default.createElement(
                      'label',
                      { className: _SeeMoreModal2.default.label },
                      'Price'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      item.price
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _SeeMoreModal2.default.info },
                    _react2.default.createElement(
                      'label',
                      { className: _SeeMoreModal2.default.label },
                      'Store'
                    ),
                    item.store_url ? _react2.default.createElement(
                      'a',
                      { href: item.store_url },
                      item.store_url
                    ) : _react2.default.createElement(
                      'p',
                      null,
                      'Unavailable'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: _SeeMoreModal2.default.info },
                    _react2.default.createElement(
                      'label',
                      { className: _SeeMoreModal2.default.label },
                      'Product link'
                    ),
                    item.link ? _react2.default.createElement(
                      'a',
                      { href: item.link },
                      'See product'
                    ) : _react2.default.createElement(
                      'p',
                      null,
                      'Unavailable'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'col--4-of-4' },
              _react2.default.createElement(
                'button',
                { className: _SeeMoreModal2.default.buttonClose, onClick: function onClick() {
                    return _onClose(item);
                  } },
                'Close'
              )
            )
          )
        )
      );
    }
  }]);
  return SeeMoreModal;
}(_react.Component);

exports.default = SeeMoreModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Item/SeeMoreModal/SeeMoreModal.js
 ** module id = 1099
 ** module chunks = 0
 **/